import { getApiActionTypesValues } from '../redux_utils';

const HOME_LISTING_FLOW = {
  FETCH_STEP_DATA: 'FETCH_LISTING_STEP_DATA',
  UPDATE_STEP_DATA: 'UPDATE_LISTING_STEP_DATA',
  FETCH_DISCLOSURE_CONFIGURATIONS: 'FETCH_DISCLOSURE_CONFIGURATIONS',
};

export const fetchStepData = (flowId, mappedStep) => ({
  types: getApiActionTypesValues(HOME_LISTING_FLOW.FETCH_STEP_DATA),
  promise: ({ client }) =>
    client.get(
      `/homeowners/listing/${flowId}/${mappedStep?.group?.key}/${mappedStep?.key}/${mappedStep?.uniqueId}`,
    ),
  auth: true,
});

export const fetchDisclosureConfigurations = () => ({
  types: getApiActionTypesValues(
    HOME_LISTING_FLOW.FETCH_DISCLOSURE_CONFIGURATIONS,
  ),
  promise: ({ client }) => client.get('/disclosure-configurations'),
  auth: true,
});

// HTTP GET /disclosure-configurations

export const updateStepData =
  (flowId, mappedStep, stepFormData) => (dispatch) =>
    dispatch({
      types: getApiActionTypesValues(HOME_LISTING_FLOW.UPDATE_STEP_DATA),
      promise: ({ client }) =>
        client.put(
          `/homeowners/listing/${flowId}/${mappedStep.group.key}/${mappedStep.key}/${mappedStep.uniqueId}`,
          {
            ...stepFormData,
          },
        ),
      auth: true,
    });
